export const deleteClientRefreshToken = () => document.cookie = "consumerClientRefreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC;";